import { ContactView } from '../../models/business/contact/contact-view';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { mockEnvironment } from "@shared/models/project-constant/constant";
@Injectable()
export class LeadService {
    public token: string;

    constructor(private http: HttpClient) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    fetchAllLeads(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/list`, query);
    }

    fetchAllLeadsByLatLng(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/get_lead_latlong`, query);
    }

    fetchLeadDetail(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/leaddetails`, query);
    }

    fetchGroupDetailById(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/getgroupjob`, query);
    }

    getLeadsCount(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/list_count`, query);
    }

    getBoroughTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/borough`);
    }

    getWorkTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/work`);
    }

    getJobProgressTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/jobprg`);
    }

    getJobTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/jobtype`);
    }

    getZipCodeTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/zipcode`);
    }


    addNotesMapping(data): Observable<any> {
        return this.http.post(`${environment.api}lead/createnote`, data);
    }

    fetchNoteMappings(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/note_list`, query);
    }

    getNotesMappingCount(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/note_list_count`, query);
    }

    updateNotesMapping(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/updatenote`, data);
    }

    saveImagesToDB(images: any): Observable<any> {
        return this.http.post(`${environment.api}lead/creategallary`, images);
    }

    getNycDobInfo(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/lead_permitdob`, query);
    }
    getLeadMapping() {
        return this.http.get(`${mockEnvironment.mockURL}/orgpermittelead.json`);
    }

    getLeadMapcountByOrg(queryData) {
        return this.http.post(`${environment.api}lead/get_org_lead/count`, queryData);
    }
    getLeadMappingByOrg(queryData) {
        return this.http.post(`${environment.api}lead/get_org_lead`, queryData);
    }

    getLeadMapcountByCon(queryData) {
        return this.http.post(`${environment.api}lead/get_contact_lead/count`, queryData);
    }

    getLeadMappingByCon(queryData) {
        return this.http.post(`${environment.api}lead/get_contact_lead`, queryData);
    }

    getLeadMapcountByOpp(queryData) {
        return this.http.post(`${environment.api}lead/get_oppty_lead/count`, queryData);
    }
    getLeadMappingByOpp(queryData) {
        return this.http.post(`${environment.api}lead/get_oppty_lead`, queryData);
    }

    createPermittee(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/permitee_insert`, data);
    }

    createOwner(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/owner_insert`, data);
    }

    getGalleryImages(query: any): Observable<any> {
        return this.http.post(`${environment.api}lead/gallery_list`, query)
    }

    createGroup(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/creategroup`, data);
    }

    fetchOppByTags(value) {
        return this.http.post(`${environment.api}opptynamemap`, { 'active': 1, 'oppty_name': value });
    }

    createOpportunityByGroup(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/createextistingoppty`, data);
    }

    createNewOpportunity(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/createoppty`, data);
    }

    getBuildingTypes(): Observable<any> {
        return this.http.get(`${environment.api}leadtype/bldgtype`);
    }

    updatePermitteeDesignation(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/updatepermitteebusiness`, data);
    }

    updateOwnerDesignation(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/updateownerdesignation`, data);
    }

    updatePermitteePotentialStatus(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/update_per_potential_status`, data);
    }

    updateOwnerPotentialStatus(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/update_owner_potential_status`, data);
    }

    updatePermitteePotentialModeStatus(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/update_per_potential_mode_status`, data);
    }

    updateOwnerPotentialModeStatus(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/update_owner_potential_mode_status`, data);
    }

    saveDraft(data: any): Observable<any> {
        return this.http.post(`${environment.api}lead/update_save_later`, data);
    }

    updateAddress(data: any) {
        return this.http.put(`${environment.api}lead/address`, data);
    }
    deleteGalleryImage(gallery_image_id) {
        return this.http.delete(`${environment.api}lead/image_delete/` + gallery_image_id);
    }
    setJobStatus(data:any){
        return this.http.post(`${environment.api}lead/change_job_status`,data);
    }

    createOrgContact(data){
        return this.http.post(`${environment.api}lead/lead_con_org`,data);
    }

    removeGroup(data){
        return this.http.post(`${environment.api}lead/remove_group`,data);
    }

    removeJob(data){
        return this.http.post(`${environment.api}lead/remove_job`,data);
    }

    getAutoOrg(query: any) : Observable<any>{
        return this.http.post(`${environment.api}lead/orgmap`,query);
    }

    getAutoCon(query: any) : Observable<any>{
        return this.http.post(`${environment.api}lead/contactmap`,query);
    }

    getUniqueData(query: any){
        return this.http.post(`${environment.api}lead/get_org_lead_unique`,query);
    }

    getUniqueDataCount(query: any){
        return this.http.post(`${environment.api}lead/get_org_lead/unique_count`,query);
    }
    getUniqueConData(query: any){
        return this.http.post(`${environment.api}lead/get_contact_lead_unique`,query);
    }
    getUniqueConDataCount(query: any){
        return this.http.post(`${environment.api}lead/get_contact_lead/unique_count`,query);
    }
    deleteNote(query: any){
        return this.http.post(`${environment.api}lead/deletenote`,query);
    }

    updateGroup(query:any){
        return this.http.post(`${environment.api}lead/updategroup`,query);
    }

    linkExistingOrgContact(query:any){
        return this.http.post(`${environment.api}lead/addtoexistconorg`,query);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/leads/leads.service.ts